<template>
<div>
    <loadingcomp v-bind:mesaj="loadingmesaj" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog persistent max-width="700px" v-model="dialog" @keydown.esc="cancel">
        <v-card>
            <v-card-title style="background-color:#01579B">
                <span class="headline white--text">{{$t('Do-Not-Change-Current-Code')}}</span>
            </v-card-title>
            <v-card-text class="pa-4">
                <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                        <v-form ref="cariKodDegistir">
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <cariaracomp v-bind:etiket="$t('Previous-Account-Code')" v-bind:value="cariDegistirRequest.EskiCari" v-model="cariDegistirRequest.EskiCari"></cariaracomp>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12 mt-1>
                                <v-layout row wrap>
                                    <cariaracomp v-bind:etiket="$t('New-Account-Code')" v-bind:value="cariDegistirRequest.YeniCari" v-model="cariDegistirRequest.YeniCari"></cariaracomp>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12 mt-1>
                                <v-layout row wrap>
                                    <v-switch v-model="cariDegistirRequest.TarihBool" :label="$t('Conduct-Changes-Per-Entry-Dates')"></v-switch>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12 v-if="cariDegistirRequest.TarihBool">
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                        <tarihcomp :etiket="$t('Starting-Date')" v-bind:detaygizle="true" v-bind:defaultvalue="'no'" v-bind:value="cariDegistirRequest.BaslangicTarih" v-model="cariDegistirRequest.BaslangicTarih">
                                        </tarihcomp>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6>
                                        <tarihcomp :etiket="$t('Finishing-Date')" v-bind:detaygizle="true" v-bind:defaultvalue="'no'" v-bind:value="cariDegistirRequest.BitisTarih" v-model="cariDegistirRequest.BitisTarih">
                                        </tarihcomp>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex>
                                <v-layout row wrap>
                                    <v-checkbox v-model="tumSirketler" :label="$t('All-Companies')"></v-checkbox>
                                </v-layout>
                            </v-flex>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click.native="agree"> {{ $t('Change') }} </v-btn>
                <v-btn color="grey" text @click.native="cancel">{{$t("cancel_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import tarihcomp from '@/components/app/customcomp/tarihim'
import auth from '../../../../../api/auth'
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp"

export default {
     data() {
        return {
        dialog: false,
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: 'Cari Hesap Kod Değiştirme',
        tumSirketler: false,
        cariDegistirRequest: {
            SirketKodu: null,
            EskiCari: null,
            YeniCari: null,
            TarihBool: false,
            BaslangicTarih: null,
            BitisTarih: null
        }
        }
    },
    components: {
        cariaracomp,
        tarihcomp,
        loadingcomp,
        snackbarcomp
    },
    methods: {
        open() {
            this.dialog = true
        },
        agree() {
            this.loadingvmodel = true
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            if(this.cariDegistirRequest.EskiCari == null || this.cariDegistirRequest.EskiCari == ""){
                this.snackbar =true;
                this.text1 = "Eski Cari Hesap kodu seçiniz "
                this.loadingvmodel = false
                return false;
            }

            if(this.cariDegistirRequest.YeniCari == null || this.cariDegistirRequest.YeniCari == ""){
                this.snackbar =true;
                this.text1 = "Yeni Cari Hesap kodu seçiniz "
                this.loadingvmodel = false
                return false;
            }
            if (this.tumSirketler == true) {
                this.cariDegistirRequest.SirketKodu = 0
            } else {
                this.cariDegistirRequest.SirketKodu = credentials.SirketKodu
            }
            var params = this.cariDegistirRequest

            this.$http.post(auth.API_URL + 'api/Current/CurrentAllChange', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if (response.body.Status) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.loadingvmodel = false
                    this.dialog = false
                }
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.loadingvmodel = false
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.loadingvmodel = false
                }
            })

        },
        cancel() {
            this.dialog = false
        }
    }
}
</script>

<style>

</style>
